export const enum OtpErrorCode {
  REJECTED = 'REJECTED',
  REJECTEDMULTIPLE = 'REJECTEDMULTIPLE',
  TOOMANYATTEMPTS = 'TOOMANYATTEMPTS',
  EXPIRED = 'EXPIRED',
  LOCKEDACCOUNT = 'LOCKEDACCOUNT',
  NORECIPIENTS = 'NORECIPIENTS',
  SYSTEMERROR = 'SYSTEMERROR'
}

export class OtpErrorDefinition {
  private static otpErrorDefinitions = {
    [OtpErrorCode.REJECTED]: {
      lockedAccount: false,
      fatalError: false,
      errorTitle: null,
      errorMessages: [
        'Security code is invalid.'
      ]
    },
    [OtpErrorCode.REJECTEDMULTIPLE]: {
      lockedAccount: false,
      fatalError: false,
      errorTitle: null,
      errorMessages: [
        'Security code is invalid. Please try again. You have {remainingAttempts} remaining before we temporarily ' +
        'lock your account.'
      ]
    },
    [OtpErrorCode.TOOMANYATTEMPTS]: {
      lockedAccount: true,
      fatalError: true,
      errorTitle: 'Account locked',
      errorMessages: [
        'Your account has been temporarily locked after too many failed verification attempts. ' +
        'Please try again in 60 minutes.'
      ]
    },
    [OtpErrorCode.EXPIRED]: {
      lockedAccount: false,
      fatalError: false,
      errorTitle: null,
      errorMessages: [
        'Security code has expired. Please resend code.'
      ]
    },
    [OtpErrorCode.LOCKEDACCOUNT]: {
      lockedAccount: true,
      fatalError: true,
      errorTitle: 'Account locked',
      errorMessages: [
        'Your account has been temporarily locked. Please try again in {minutesToUnlock}.'
      ]
    },
    [OtpErrorCode.NORECIPIENTS]: {
      lockedAccount: false,
      fatalError: true,
      errorTitle: 'Oops!',
      errorMessages: [
        'Sorry, the mobile number on your account is missing or invalid. Please call us on {supportNumber} for assistance.'
      ]
    },
    [OtpErrorCode.SYSTEMERROR]: {
      lockedAccount: false,
      fatalError: true,
      errorTitle: 'Oops!',
      errorMessages: [
        'A system error has occurred. Please try logging in again later.'
      ]
    }
  };

  readonly errorCode: OtpErrorCode;
  readonly lockedAccount: boolean;
  readonly fatalError: boolean;
  readonly errorTitle: string;
  readonly errorMessages: string[];

  constructor(errorCode: OtpErrorCode, lockedAccount: boolean, fatalError: boolean, errorTitle: string, errorMessages: string[]) {
    this.errorCode = errorCode;
    this.lockedAccount = lockedAccount;
    this.fatalError = fatalError;
    this.errorTitle = errorTitle;
    this.errorMessages = errorMessages;
  }

  public static for(errorCode: string): OtpErrorDefinition {
    let otpErrorCode = errorCode as OtpErrorCode;
    if (!this.otpErrorDefinitions[otpErrorCode]) {
      otpErrorCode = OtpErrorCode.SYSTEMERROR;
    }
    let definition = this.otpErrorDefinitions[otpErrorCode];

    return new OtpErrorDefinition(
      otpErrorCode,
      definition.lockedAccount,
      definition.fatalError,
      definition.errorTitle,
      definition.errorMessages
    );
  }
}
